import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AdminProvider } from "./context/AdminContext";
import { DistributorProvider } from "./context/DistributorContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AIChatWidget from "./components/AIChatWidget";
import PackTipToast from "./components/PackTipToast";
import ScrollToTop from "./components/ScrollToTop";
import I18nBetaBanner from "./components/I18nBetaBanner";
import GlobalSeoFallback from "./components/GlobalSeoFallback";
import NoIndexMeta from "./components/NoIndexMeta";
import LangSync from "./i18n/LangSync";

import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import ConfiguratorPage from "./pages/ConfiguratorPage";
import IndustriesPage from "./pages/IndustriesPage";
import IndustryDetailPage from "./pages/IndustryDetailPage";
import CartPage from "./pages/CartPage";
import BulkOrderPage from "./pages/BulkOrderPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import ConversionPage from "./pages/ConversionPage";
import DnLandingPage from "./pages/DnLandingPage";
import InchLandingPage from "./pages/InchLandingPage";
import PipeScanPage from "./pages/PipeScanPage";
import SeoLandingPage from "./pages/SeoLandingPage";
import BlogIndexPage from "./pages/BlogIndexPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import ContactPage from "./pages/ContactPage";
import StainlessSteelPipeClampsPage from "./pages/StainlessSteelPipeClampsPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminPage from "./pages/AdminPage";
import DistributorLoginPage from "./pages/DistributorLoginPage";
import DistributorRegisterPage from "./pages/DistributorRegisterPage";
import DistributorDashboardPage from "./pages/DistributorDashboardPage";

function Layout() {
  return (
    <div className="App">
      <GlobalSeoFallback />
      <I18nBetaBanner />
      <Header />
      <main className="min-h-[60vh]">
        <Outlet />
      </main>
      <Footer />
      <AIChatWidget />
      <PackTipToast />
    </div>
  );
}

// Centralised route table — same tree mounted at root (NL) and under each
// language prefix /en, /de, /fr, /es. Defined as a function so it can be
// invoked multiple times in the Routes config.
const buildLocalisedRoutes = () => (
  <>
    <Route index element={<HomePage />} />
    <Route path="stainless-steel-pipe-clamps" element={<StainlessSteelPipeClampsPage />} />
    <Route path="products" element={<ProductsPage />} />
    <Route path="products/:id" element={<ProductDetailPage />} />
    <Route path="configurator" element={<ConfiguratorPage />} />
    <Route path="industries" element={<IndustriesPage />} />
    <Route path="industries/:slug" element={<IndustryDetailPage />} />
    <Route path="conversion" element={<ConversionPage />} />
    <Route path="dn/:dn" element={<DnLandingPage />} />
    <Route path="inch/:inchSlug" element={<InchLandingPage />} />
    <Route path="pipe-scan" element={<PipeScanPage />} />
    <Route path="landing/:slug" element={<SeoLandingPage />} />
    <Route path="blog" element={<BlogIndexPage />} />
    <Route path="blog/:slug" element={<BlogDetailPage />} />
    <Route path="contact" element={<ContactPage />} />
    <Route path="cart" element={<CartPage />} />
    <Route path="bulk-order" element={<BulkOrderPage />} />
    <Route path="checkout" element={<CheckoutPage />} />
    <Route path="order/:orderNumber" element={<OrderSuccessPage />} />
    <Route path="distributor/login" element={<DistributorLoginPage />} />
    <Route path="distributor/register" element={<DistributorRegisterPage />} />
    <Route path="distributor/dashboard" element={<DistributorDashboardPage />} />
  </>
);

function App() {
  return (
    <AdminProvider>
      <DistributorProvider>
        <CartProvider>
          <BrowserRouter>
            <LangSync />
            <ScrollToTop />
            <Routes>
            {/* Admin routes — bare layout, no header/footer */}
            <Route path="/admin/login" element={<><NoIndexMeta /><AdminLoginPage /></>} />
            <Route path="/admin" element={<><NoIndexMeta /><AdminPage /></>} />

            {/* NL default — root mount */}
            <Route path="/" element={<Layout />}>
              {buildLocalisedRoutes()}
            </Route>

            {/* Language-prefixed mounts: /en/*, /de/*, /fr/*, /es/*, /it/*, /pl/*, /pt/*, /sv/*, /da/* */}
            <Route path="/en" element={<Layout />}>{buildLocalisedRoutes()}</Route>
            <Route path="/de" element={<Layout />}>{buildLocalisedRoutes()}</Route>
            <Route path="/fr" element={<Layout />}>{buildLocalisedRoutes()}</Route>
            <Route path="/es" element={<Layout />}>{buildLocalisedRoutes()}</Route>
            <Route path="/it" element={<Layout />}>{buildLocalisedRoutes()}</Route>
            <Route path="/pl" element={<Layout />}>{buildLocalisedRoutes()}</Route>
            <Route path="/pt" element={<Layout />}>{buildLocalisedRoutes()}</Route>
            <Route path="/sv" element={<Layout />}>{buildLocalisedRoutes()}</Route>
            <Route path="/da" element={<Layout />}>{buildLocalisedRoutes()}</Route>
          </Routes>
        </BrowserRouter>
        </CartProvider>
      </DistributorProvider>
    </AdminProvider>
  );
}

export default App;
